import React from "react";

export default function ReferenceAttachments({ field, openViewer }) {
  if (!field?.attachments || field.attachments.length === 0) {
    return null;
  }

  return (
    <div className="mb-3 flex gap-2 flex-wrap justify-center">
      {field.attachments.map((att) => (
        <img
          key={att.url}
          src={att.url}
          alt={att.name}
          className="w-14 h-14 object-cover rounded border border-gray-300 shadow-sm cursor-pointer hover:shadow-md transition-shadow"
          onClick={() => openViewer?.(att.url)}
        />
      ))}
    </div>
  );
}
